export default "__VITE_ASSET__D7JXkx6t__"